export const l_grid__item_GridColumnEnd = {
  "name": "--pf-l-grid__item--GridColumnEnd",
  "value": "span 12",
  "var": "var(--pf-l-grid__item--GridColumnEnd)"
};
export default l_grid__item_GridColumnEnd;